'use client';

import { Media } from '@backbone-one/contentful-client';
import { HeroUIProvider, ToastProvider } from '@heroui/react';
import CustomizationsProvider from './customizations-provider';
import { NextIntlClientProvider } from 'next-intl';

export function Providers({
  children,
  customizations,
  messages,
}: {
  children: React.ReactNode;
  customizations: Record<string, Media>;
  messages: Record<string, string>;
}) {
  return (
    <NextIntlClientProvider
      locale={'de'}
      messages={messages}
      onError={(error) => {
        if (error.code === 'MISSING_MESSAGE') {
          console.warn(error);
          return;
        }
        throw error;
      }}
    >
      <CustomizationsProvider customizations={customizations}>
        <HeroUIProvider>
          <ToastProvider maxVisibleToasts={1} toastProps={{ timeout: 20000 }} />
          {children}
        </HeroUIProvider>
      </CustomizationsProvider>
    </NextIntlClientProvider>
  );
}
